export default "__VITE_ASSET__CJHltDv0__"